import fetch from "isomorphic-unfetch"

export interface Postbox {
  postboxId: string
  name: string
  address: string
  postcode: string
  town: string
  latitude: string
  longitude: string
}

export interface PostboxResponse {
  postboxes: Postbox[]
  meta?: {
    error?: unknown
    status: number
  }
}

export const fetchIcelandPostboxes = async (): Promise<PostboxResponse> => {
  return fetch("/api/postboxes", {}).then(response => {
    return response.json() as Promise<PostboxResponse>
  })
}
